import * as React from 'react';
import { Box, Dialog } from '@chakra-ui/react';

import {
  SERVICE_DIALOG_CONTENT_PROPS,
  SERVICE_FLOW_BORDER,
} from '../ServiceFormCard';

/** Use on app `Button` in modal footers (compact actions). */
export const DIALOG_ACTION_BUTTON_PROPS = {
  size: 'sm' as const,
  h: 10,
  fontSize: 'sm',
};

type DialogContentMaxW = React.ComponentProps<typeof Dialog.Content>['maxW'];

export type ServiceDialogShellOptions = {
  maxW?: DialogContentMaxW;
  minW?: DialogContentMaxW;
  mx?: string | number;
};

export function serviceDialogShellProps(
  options: ServiceDialogShellOptions = {}
) {
  const { maxW = 'md', minW, mx = 4 } = options;
  return {
    ...SERVICE_DIALOG_CONTENT_PROPS,
    mx,
    p: 0,
    position: 'relative' as const,
    w: 'full',
    maxW,
    ...(minW ? { minW } : {}),
  };
}

type HeaderProps = React.ComponentProps<typeof Dialog.Header>;

export const ServiceDialogHeader: React.FC<
  React.PropsWithChildren<HeaderProps>
> = ({ children, ...rest }) => (
  <Dialog.Header
    px={{ base: 5, md: 6 }}
    pt={{ base: 5, md: 6 }}
    pb={3}
    mb={0}
    borderBottomWidth="1px"
    borderBottomColor={SERVICE_FLOW_BORDER}
    fontSize="md"
    fontWeight="semibold"
    color="body"
    {...rest}
  >
    {children}
  </Dialog.Header>
);

export const ServiceDialogCloseTrigger: React.FC = () => (
  <Box position="absolute" top={3} insetInlineEnd={3} zIndex={1}>
    <Dialog.CloseTrigger
      _hover={{ bg: 'rgba(255,255,255,0.08)' }}
      rounded="md"
    />
  </Box>
);

type BodyProps = React.ComponentProps<typeof Dialog.Body>;

export const ServiceDialogBody: React.FC<
  React.PropsWithChildren<BodyProps>
> = ({ children, px, py, ...rest }) => (
  <Dialog.Body
    px={px ?? { base: 5, md: 6 }}
    py={py ?? 5}
    overflowY="auto"
    {...rest}
  >
    {children}
  </Dialog.Body>
);

export const ServiceDialogFooter: React.FC<React.PropsWithChildren> = ({
  children,
}) => (
  <Box
    px={{ base: 5, md: 6 }}
    py={4}
    borderTopWidth="1px"
    borderTopColor={SERVICE_FLOW_BORDER}
  >
    {children}
  </Box>
);
